import NotFoundView from 'src/sections/error/view/not-found-view';

// ----------------------------------------------------------------------

export default function NotFoundPage() {
  return <NotFoundView />;
}
